// @ts-nocheck
import { useContext } from 'react'
import { useDispatch } from 'react-redux'

import { DOCUMENT_TYPE } from 'shared/consts/checkout'
import store from 'shared/store'
import { deleteCartItemAction } from 'shared/store/ducks/cart'
import { deleteCartOffersAction } from 'shared/store/ducks/cart/actions'
import { showModalDeclarativeAction } from 'shared/store/ducks/events'
import IconBin from 'views/components/atoms/Icon/IconBin'
import ButtonWithIcon from 'views/components/molecules/ButtonWithIcon'
import { DeleteEPrescriptionEntryContext } from 'views/components/organisms/Cart/DeleteEPrescriptionEntryContext'
import { ODS_MODAL_ID } from 'views/consts'

const ProductListingDeleteButton = ({
  isERx,
  product,
  evaluatedProductType,
  setGreyedOut,
}) => {
  const [, setEPrescriptionHashedToken] = useContext(
    DeleteEPrescriptionEntryContext
  )

  const dispatch = useDispatch()

  return (
    <ButtonWithIcon
      component="ButtonTransparent"
      id={`productListItemDelete__${
        isERx ? product.hashedToken : product.productId
      }`}
      name="cart-entry-deleteEntry-button"
      onClick={() => {
        if (evaluatedProductType === DOCUMENT_TYPE.ODS_SECTION) {
          dispatch(showModalDeclarativeAction(ODS_MODAL_ID))
        } else if (isERx) {
          setEPrescriptionHashedToken(product.hashedToken)
          dispatch(showModalDeclarativeAction('deleteEPrescriptionModal'))
        } else {
          setGreyedOut(greyedOut => [...greyedOut, product.offerId])

          /*  In order to solve the concurrency problem during the deletion
         of multiple cart items at the same time, it is necessary to store
         the requests in the queue and then execute the request one by one.*/

          const { offers } = store.getState().cart
          offers.push({
            offerId: product.offerId,
            pType: evaluatedProductType,
          })

          dispatch(deleteCartOffersAction(offers))
          dispatch(deleteCartItemAction())
        }
      }}
      icon={<IconBin />}
    />
  )
}

export default ProductListingDeleteButton
